var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpsell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 404.067,
    height: 280.752,
    viewBox: "0 0 404.067 280.752",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_13039",
    x: 115.407,
    y: 64.452,
    width: 207.388,
    height: 164.092,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_13042",
    x: 99.989,
    y: 138.021,
    width: 236.037,
    height: 142.731,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Software_integration-pana",
    "data-name": "Software integration-pana",
    transform: "translate(-133.98 -44.99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-92",
    transform: "translate(230.11 50.733)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1678",
    "data-name": "Rectangle 1678",
    width: 40.517,
    height: 40.527,
    rx: 10.38,
    transform: "translate(222.446 34.32)",
    fill: "#59c0ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13003",
    "data-name": "Path 13003",
    d: "M230.555,61.6a4.963,4.963,0,0,0,2.974-4.6,4.676,4.676,0,1,0-9.342,0,4.963,4.963,0,0,0,2.974,4.645c-7.178,1.087-6.85,8.891-6.85,8.891l16.982.082S237.682,62.673,230.555,61.6Z",
    transform: "translate(13.909 -7.228)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13004",
    "data-name": "Path 13004",
    d: "M237.313,70.592h0L220.3,70.52h0a11.281,11.281,0,0,1,.738-4.1,7.877,7.877,0,0,1,2.051-3.015,7.681,7.681,0,0,1,4.02-1.836,4.963,4.963,0,0,1-2.9-4.635,5.127,5.127,0,0,1,1.384-3.528,4.553,4.553,0,0,1,3.261-1.4h0a4.871,4.871,0,0,1,4.676,5.025,4.984,4.984,0,0,1-2.9,4.594,7.588,7.588,0,0,1,3.989,1.846,7.926,7.926,0,0,1,1.979,3.076,11.136,11.136,0,0,1,.7,4.1Zm-16.982-.133,16.941.072a11.8,11.8,0,0,0-.7-4.04,7.855,7.855,0,0,0-1.979-3.076,7.455,7.455,0,0,0-4.04-1.846h-.01a4.933,4.933,0,0,0,2.953-4.584A4.81,4.81,0,0,0,228.873,52h0a4.461,4.461,0,0,0-3.261,1.436,5.066,5.066,0,0,0-1.374,3.5,4.9,4.9,0,0,0,2.933,4.645h0a7.65,7.65,0,0,0-4.1,1.836,7.794,7.794,0,0,0-2.051,2.994A11.354,11.354,0,0,0,220.331,70.459Z",
    transform: "translate(-207.051 -52)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1679",
    "data-name": "Rectangle 1679",
    width: 46.127,
    height: 46.137,
    rx: 10.38,
    transform: "translate(0 162.171)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13006",
    "data-name": "Path 13006",
    d: "M232.12,232.671a5.651,5.651,0,0,0,3.374-5.24,5.322,5.322,0,1,0-10.624,0,5.64,5.64,0,0,0,3.384,5.292c-8.2,1.231-7.8,10.122-7.8,10.122l19.331.092S240.222,233.9,232.12,232.671Z",
    transform: "translate(-207.047 -47.672)",
    fill: "#59c0ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-92",
    transform: "translate(133.98 172.993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13007",
    "data-name": "Path 13007",
    d: "M.267,0C.41,0,.533,16.665.533,37.529S.41,75.058.267,75.058,0,58.393,0,37.529.113,0,.267,0Z",
    transform: "translate(148.094 32.277) rotate(90)",
    fill: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1680",
    "data-name": "Rectangle 1680",
    width: 26.006,
    height: 26.006,
    transform: "translate(7.061 24.714)",
    fill: "#59c0ea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1681",
    "data-name": "Rectangle 1681",
    width: 26.786,
    height: 2.225,
    transform: "translate(39.62 26.294)",
    fill: "#59c0ea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1682",
    "data-name": "Rectangle 1682",
    width: 26.786,
    height: 2.225,
    transform: "translate(39.62 31.431)",
    fill: "#59c0ea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1683",
    "data-name": "Rectangle 1683",
    width: 26.786,
    height: 2.225,
    transform: "translate(39.62 36.579)",
    fill: "#59c0ea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1684",
    "data-name": "Rectangle 1684",
    width: 26.786,
    height: 2.225,
    transform: "translate(39.62 41.727)",
    fill: "#59c0ea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1685",
    "data-name": "Rectangle 1685",
    width: 26.786,
    height: 2.225,
    transform: "translate(39.62 46.865)",
    fill: "#59c0ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13008",
    "data-name": "Path 13008",
    d: "M355.7,288.18h56.669a7.23,7.23,0,0,1,7.23,7.23v10.163H348.57V295.317A7.178,7.178,0,0,1,355.7,288.18Z",
    transform: "translate(-348.349 -287.913)",
    fill: "#59c0ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13009",
    "data-name": "Path 13009",
    d: "M412.976,350.69a7.753,7.753,0,0,0,2.513-.554,6.656,6.656,0,0,0,2.482-1.846,6.481,6.481,0,0,0,1.507-3.876c0-6.481,0-15.834-.061-27.381V295.55a7.7,7.7,0,0,0-.277-2.523,6.471,6.471,0,0,0-5.743-4.574c-.882-.051-1.836,0-2.759,0h-55.4a6.521,6.521,0,0,0-3.077.749,6.368,6.368,0,0,0-2.287,2.112,6.152,6.152,0,0,0-1.025,2.923c-.051,1.026,0,2.154,0,3.21v45.122a13.579,13.579,0,0,0,.123,2.687,6.574,6.574,0,0,0,2.841,4.153,6.461,6.461,0,0,0,2.328.933,12.811,12.811,0,0,0,2.523.123h18.91l27.391.092,7.445.051h0l-7.445.051-27.391.082h-18.91a14,14,0,0,1-2.6-.113,7.045,7.045,0,0,1-5.548-5.445,14.16,14.16,0,0,1-.144-2.779V294.2a6.8,6.8,0,0,1,1.077-3.179,6.994,6.994,0,0,1,2.482-2.287,7.086,7.086,0,0,1,3.3-.81h58.186a6.7,6.7,0,0,1,2.707.769,6.912,6.912,0,0,1,3.435,4.1,8.144,8.144,0,0,1,.3,2.656v21.484c0,11.568,0,20.92-.1,27.391a6.707,6.707,0,0,1-1.6,3.969,6.789,6.789,0,0,1-2.564,1.846,6.6,6.6,0,0,1-1.887.441Z",
    transform: "translate(-348.355 -287.92)",
    fill: "#59c0ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13010",
    "data-name": "Path 13010",
    d: "M5.989,2.984A2.994,2.994,0,1,1,3,0,2.994,2.994,0,0,1,5.989,2.984Z",
    transform: "translate(75.558 29.549) rotate(90)",
    fill: "#ee3d4a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chart--inject-92",
    transform: "translate(206.103 97.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13011",
    "data-name": "Path 13011",
    d: "M271.521,190.214a5.536,5.536,0,0,1-.708,0l-2.051.051-7.486.082-24.7.082H233a13.147,13.147,0,0,1-1.784-.062,6.152,6.152,0,0,1-1.713-.5,8.009,8.009,0,0,1-4.246-5.015,10.4,10.4,0,0,1-.441-3.076v-2.882c0-1.846,0-3.579.072-5.127,0-3.076.1-5.65.133-7.486q0-1.261.061-2.051a3.079,3.079,0,0,1,.062-.708,3.719,3.719,0,0,1,0,.708v14.716a17.6,17.6,0,0,0,.441,5.815,7.589,7.589,0,0,0,3.979,4.687,6.049,6.049,0,0,0,1.579.451,13.331,13.331,0,0,0,1.713.062h3.569l24.7.072,7.486.082,2.051.051a3.23,3.23,0,0,1,.851.051Z",
    transform: "translate(-182.929 -96.114)",
    fill: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1686",
    "data-name": "Rectangle 1686",
    width: 62.504,
    height: 62.504,
    rx: 10.38,
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1687",
    "data-name": "Rectangle 1687",
    width: 7.886,
    height: 6.04,
    transform: "translate(9.958 43.696)",
    fill: "#59c0ea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1688",
    "data-name": "Rectangle 1688",
    width: 7.886,
    height: 19.966,
    transform: "translate(19.936 29.77)",
    fill: "#59c0ea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1689",
    "data-name": "Rectangle 1689",
    width: 7.886,
    height: 11.362,
    transform: "translate(30.908 38.364)",
    fill: "#59c0ea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1690",
    "data-name": "Rectangle 1690",
    width: 7.886,
    height: 25.75,
    transform: "translate(41.379 23.976)",
    fill: "#59c0ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13013",
    "data-name": "Path 13013",
    d: "M197.1,134.525a3.928,3.928,0,1,1,3.928-3.928,3.928,3.928,0,0,1-3.928,3.928Zm0-6.82A2.9,2.9,0,1,0,200,130.6a2.9,2.9,0,0,0-2.9-2.892Z",
    transform: "translate(-183.735 -97.054)",
    fill: "#59c0ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13014",
    "data-name": "Path 13014",
    d: "M208.1,119.965a3.928,3.928,0,1,1,3.928-3.928,3.928,3.928,0,0,1-3.928,3.928Zm0-6.83a2.9,2.9,0,1,0,2.9,2.9A2.9,2.9,0,0,0,208.1,113.135Z",
    transform: "translate(-183.455 -97.425)",
    fill: "#59c0ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13015",
    "data-name": "Path 13015",
    d: "M218.1,129.2a3.928,3.928,0,1,1,3.928-3.928A3.928,3.928,0,0,1,218.1,129.2Zm0-6.82a2.9,2.9,0,1,0,0-.01Z",
    transform: "translate(-183.2 -97.19)",
    fill: "#59c0ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13016",
    "data-name": "Path 13016",
    d: "M228.688,115.815a3.928,3.928,0,1,1,3.928-3.928,3.928,3.928,0,0,1-3.928,3.928Zm0-6.83a2.882,2.882,0,1,1,0,.041Z",
    transform: "translate(-182.93 -97.531)",
    fill: "#59c0ea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1691",
    "data-name": "Rectangle 1691",
    width: 11.014,
    height: 1.025,
    transform: "matrix(0.575, -0.818, 0.818, 0.575, 36.689, 25.565)",
    fill: "#59c0ea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1692",
    "data-name": "Rectangle 1692",
    width: 1.025,
    height: 6.973,
    transform: "matrix(0.723, -0.691, 0.691, 0.723, 26.906, 21.724)",
    fill: "#59c0ea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1693",
    "data-name": "Rectangle 1693",
    width: 11.588,
    height: 1.025,
    transform: "matrix(0.613, -0.79, 0.79, 0.613, 14.848, 30.386)",
    fill: "#59c0ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13017",
    "data-name": "Path 13017",
    d: "M229.389,159.524a2.994,2.994,0,1,1-2.984-2.984,2.994,2.994,0,0,1,2.984,2.984Z",
    transform: "translate(-182.965 -96.292)",
    fill: "#ee3d4a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Search--inject-92",
    transform: "translate(291.414 44.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13018",
    "data-name": "Path 13018",
    d: "M299.367,146.026c-.144,0-.267-8.614-.267-19.238s.123-19.238.267-19.238.267,8.614.267,19.238S299.51,146.026,299.367,146.026Z",
    transform: "translate(-266.346 -44.841)",
    fill: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1694",
    "data-name": "Rectangle 1694",
    width: 62.504,
    height: 62.504,
    rx: 10.38,
    transform: "translate(0 0)",
    fill: "#59c0ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13020",
    "data-name": "Path 13020",
    d: "M302.368,107.414a2.984,2.984,0,1,1-2.984-2.984A2.984,2.984,0,0,1,302.368,107.414Z",
    transform: "translate(-266.415 -44.921)",
    fill: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13021",
    "data-name": "Path 13021",
    d: "M295.616,85.216a11.366,11.366,0,1,1,10.85-7.845h0A11.414,11.414,0,0,1,295.616,85.216Zm0-20.746a9.342,9.342,0,1,0,8.891,12.214h0a9.353,9.353,0,0,0-6.03-11.762,9.23,9.23,0,0,0-2.851-.451Z",
    transform: "translate(-266.727 -45.991)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13022",
    "data-name": "Path 13022",
    d: "M310.235,91.6a1.026,1.026,0,0,1-.749-.338l-8.481-9.219a1.026,1.026,0,0,1,1.508-1.384l8.471,9.229a1.02,1.02,0,0,1-.749,1.713Z",
    transform: "translate(-266.303 -45.534)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cloud--inject-92",
    transform: "translate(368.572 66.433)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1695",
    "data-name": "Rectangle 1695",
    width: 62.504,
    height: 62.504,
    rx: 10.38,
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13025",
    "data-name": "Path 13025",
    d: "M397.031,100.578c1.569,5.5-2.051,10.87-7.64,10.87H359.775a7.394,7.394,0,0,1-7.178-9.3,5.4,5.4,0,0,1,.256-.718,7.814,7.814,0,0,1,8.491-4.615,13.454,13.454,0,0,1,26.037-2.871S395.062,93.532,397.031,100.578Z",
    transform: "translate(-342.146 -66.859)",
    fill: "#59c0ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13026",
    "data-name": "Path 13026",
    d: "M371.617,116.482V105.119h-4.451a.646.646,0,0,1-.523-1.025l7.332-10.347a.636.636,0,0,1,1.025,0L382.323,104a.646.646,0,0,1-.523,1.025h-4.338v11.444Z",
    transform: "translate(-341.785 -66.643)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Globe--inject-92",
    transform: "translate(421.456 141.909)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1696",
    "data-name": "Rectangle 1696",
    width: 62.504,
    height: 62.504,
    rx: 10.38,
    transform: "translate(54.089 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13028",
    "data-name": "Path 13028",
    d: "M440.413,190.835a19.013,19.013,0,1,1,19-19.006,19.013,19.013,0,0,1-19,19.006Zm0-36.989a17.987,17.987,0,1,0,17.977,17.984A17.987,17.987,0,0,0,440.413,153.846Z",
    transform: "translate(-354.278 -140.607)",
    fill: "#59c0ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13029",
    "data-name": "Path 13029",
    d: "M439.613,190.771a17.9,17.9,0,0,1-4.871-4.492,22.428,22.428,0,0,1-4.451-14.818A23.3,23.3,0,0,1,435.5,157a16.94,16.94,0,0,1,4.881-4.1l.451.923c-.092,0-9.035,4.625-9.517,17.69s8.706,18.336,8.8,18.387Z",
    transform: "translate(-354.052 -140.604)",
    fill: "#59c0ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13030",
    "data-name": "Path 13030",
    d: "M440.229,190.762l-.533-.872c.082-.062,8.983-5.733,8.5-18.808s-9.045-17.249-9.127-17.29l.431-.923c.379.174,9.229,4.471,9.722,18.182S440.321,190.7,440.229,190.762Z",
    transform: "translate(-353.827 -140.605)",
    fill: "#59c0ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13031",
    "data-name": "Path 13031",
    d: "M440.564,165.62c-7.691,0-12.655-2.615-15.464-4.81l.636-.81c2.677,2.1,7.425,4.594,14.829,4.594,7.178,0,11.711-2.482,14.265-4.563l.646.79C452.8,163.015,448.04,165.62,440.564,165.62Z",
    transform: "translate(-354.183 -140.423)",
    fill: "#59c0ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13032",
    "data-name": "Path 13032",
    d: "M454.869,182.3c-2.677-2.051-7.425-4.451-14.839-4.451-7.178,0-11.711,2.4-14.265,4.43l-.636-.81c2.677-2.123,7.435-4.645,14.9-4.645,7.7,0,12.655,2.533,15.464,4.656Z",
    transform: "translate(-354.182 -139.995)",
    fill: "#59c0ea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1697",
    "data-name": "Rectangle 1697",
    width: 36.549,
    height: 1.025,
    transform: "translate(68.097 30.765)",
    fill: "#59c0ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13033",
    "data-name": "Path 13033",
    d: "M411.529,172.694a2.984,2.984,0,1,1-.87-2.117A2.994,2.994,0,0,1,411.529,172.694Z",
    transform: "translate(-354.682 -140.176)",
    fill: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13034",
    "data-name": "Path 13034",
    d: "M418.222,172.627c0,.144-7.1.267-15.844.267s-39.691.144-39.691,0,30.943-.533,39.691-.533S418.222,172.473,418.222,172.627Z",
    transform: "translate(-362.687 -140.108)",
    fill: "#ee3d4a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-92",
    transform: "translate(278.97 144.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13037",
    "data-name": "Path 13037",
    d: "M400.886,263.931,387.5,216.82H270.495l-15.249,46.957a4.4,4.4,0,0,0,4.1,5.774H312.8l2.164-2.164H340.2l2.164,2.164h54.351a4.389,4.389,0,0,0,4.174-5.62Z",
    transform: "translate(-255.025 -141.508)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32028",
    "data-name": "Group 32028",
    transform: "translate(0 75.312)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13038",
    "data-name": "Path 13038",
    d: "M400.886,263.931,387.5,216.82H270.495l-15.249,46.957a4.4,4.4,0,0,0,4.1,5.774H312.8l2.164-2.164H340.2l2.164,2.164h54.351a4.389,4.389,0,0,0,4.174-5.62Z",
    transform: "translate(-255.025 -216.82)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -144.99, -99.45)",
    filter: "url(#Path_13039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13039-2",
    "data-name": "Path 13039",
    d: "M270.06,217.472V148.343a4.943,4.943,0,0,1,4.933-4.963H382.515a4.943,4.943,0,0,1,4.933,4.963v69.128Z",
    transform: "translate(-109.65 -43.93)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1699",
    "data-name": "Rectangle 1699",
    width: 103.195,
    height: 61.478,
    transform: "translate(22.515 6.84)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13040",
    "data-name": "Path 13040",
    d: "M380.18,211.535v-4.348c0-2.841,0-6.994-.062-12.306,0-10.655-.062-26-.1-44.8l.205.205-103.216.041h0l.267-.267v61.478l-.246-.246,74.225.113,21.31.072h.1l-21.248.062-74.389.123h-.246V149.79h.226l103.185.062h.205v.205c0,18.869-.082,34.251-.113,44.937,0,5.312,0,9.445-.051,12.306v3.189A7.292,7.292,0,0,1,380.18,211.535Z",
    transform: "translate(-254.471 -143.217)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13041",
    "data-name": "Path 13041",
    d: "M329.245,146.936a1.907,1.907,0,1,1-1.9-1.866,1.877,1.877,0,0,1,1.9,1.866Z",
    transform: "translate(-253.23 -143.337)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -144.99, -99.45)",
    filter: "url(#Path_13042)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13042-2",
    "data-name": "Path 13042",
    d: "M400.886,262.231,387.5,215.12H270.495l-15.249,46.957a4.4,4.4,0,0,0,4.1,5.774H312.8l2.164-2.164H340.2l2.164,2.164h54.351a4.389,4.389,0,0,0,4.174-5.62Z",
    transform: "translate(-110.04 -42.1)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13043",
    "data-name": "Path 13043",
    d: "M378.908,218.069l-101.965-.338a2.369,2.369,0,0,0-2.307,1.415l-8.2,23.2c-.441,1.261.7,2.512,2.3,2.512H386.753c1.589,0,2.738-1.241,2.3-2.5L381.205,219.5A2.4,2.4,0,0,0,378.908,218.069Z",
    transform: "translate(-254.737 -141.485)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32029",
    "data-name": "Group 32029",
    transform: "translate(49.73 106.056)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13044",
    "data-name": "Path 13044",
    d: "M346.293,261.823h-40.23a2.707,2.707,0,0,1-2.441-3.446l2.277-9.527a2.564,2.564,0,0,1,2.441-2.051h35.954a2.584,2.584,0,0,1,2.461,2.133l2.051,9.517a2.707,2.707,0,0,1-2.512,3.374Z",
    transform: "translate(-303.519 -246.8)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13045",
    "data-name": "Path 13045",
    d: "M345.317,225.355l-1.025-4.861a.718.718,0,0,0-.708-.564h-6.276a.718.718,0,0,0-.718.82l.7,4.861a.728.728,0,0,0,.718.626h6.635a.728.728,0,0,0,.677-.882Z",
    transform: "translate(-252.946 -141.429)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13046",
    "data-name": "Path 13046",
    d: "M326.856,225.468l-.451-4.881a.708.708,0,0,0-.718-.656h-6.409a.728.728,0,0,0-.728.749l.174,4.881a.728.728,0,0,0,.728.7h6.737a.728.728,0,0,0,.667-.79Z",
    transform: "translate(-253.406 -141.429)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13047",
    "data-name": "Path 13047",
    d: "M336.6,225.416l-.7-4.871a.718.718,0,0,0-.718-.615H327.8a.718.718,0,0,0-.718.79l.441,4.871a.739.739,0,0,0,.728.656h7.63a.718.718,0,0,0,.718-.831Z",
    transform: "translate(-253.188 -141.429)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13048",
    "data-name": "Path 13048",
    d: "M290.9,225.539l1.025-4.43a1.026,1.026,0,0,0-.954-1.179H284.9a1.026,1.026,0,0,0-.933.708l-1.272,4.43a1.025,1.025,0,0,0,.943,1.241h6.358A1.026,1.026,0,0,0,290.9,225.539Z",
    transform: "translate(-254.32 -141.429)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13049",
    "data-name": "Path 13049",
    d: "M377.457,225.2l-1.846-4.81a.718.718,0,0,0-.677-.461H363.018a.718.718,0,0,0-.677.974l1.795,4.82a.707.707,0,0,0,.677.472H376.8a.728.728,0,0,0,.656-.995Z",
    transform: "translate(-252.291 -141.429)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13050",
    "data-name": "Path 13050",
    d: "M317.2,219.93h-6.932a.728.728,0,0,0-.728.687l-.236,4.9a.728.728,0,0,0,.728.759h7.353a.718.718,0,0,0,.718-.749l-.174-4.892a.728.728,0,0,0-.728-.708Z",
    transform: "translate(-253.642 -141.429)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13051",
    "data-name": "Path 13051",
    d: "M282.183,219.93h-4.83a1.026,1.026,0,0,0-.923.646l-1.59,4.451a1.025,1.025,0,0,0,.913,1.3h5.127a1.025,1.025,0,0,0,.933-.708l1.272-4.44a1.025,1.025,0,0,0-.9-1.251Z",
    transform: "translate(-254.521 -141.429)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13052",
    "data-name": "Path 13052",
    d: "M299.65,225.663l.646-4.922a.718.718,0,0,0-.718-.81h-6.153a.728.728,0,0,0-.708.564l-1.1,4.922a.718.718,0,0,0,.708.882h6.635a.707.707,0,0,0,.687-.636Z",
    transform: "translate(-254.093 -141.429)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13053",
    "data-name": "Path 13053",
    d: "M301.016,220.555l-.646,4.912a.728.728,0,0,0,.728.82h6.861a.728.728,0,0,0,.728-.687l.236-4.9a.718.718,0,0,0-.728-.759h-6.461a.728.728,0,0,0-.718.615Z",
    transform: "translate(-253.869 -141.428)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13054",
    "data-name": "Path 13054",
    d: "M354.537,225.283l-1.436-4.84a.718.718,0,0,0-.7-.513h-6.686a.718.718,0,0,0-.708.872l1.026,4.851a.728.728,0,0,0,.708.574h7.076a.728.728,0,0,0,.718-.943Z",
    transform: "translate(-252.732 -141.429)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13055",
    "data-name": "Path 13055",
    d: "M363.232,225.222l-1.795-4.82a.728.728,0,0,0-.677-.472h-6.153a.718.718,0,0,0-.687.923l1.425,4.84a.728.728,0,0,0,.7.513h6.512a.738.738,0,0,0,.677-.984Z",
    transform: "translate(-252.505 -141.429)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13056",
    "data-name": "Path 13056",
    d: "M317.472,227.18H309.9a.728.728,0,0,0-.728.687l-.246,5.066a.728.728,0,0,0,.728.759h8a.738.738,0,0,0,.728-.759l-.185-5.045A.728.728,0,0,0,317.472,227.18Z",
    transform: "translate(-253.651 -141.244)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13057",
    "data-name": "Path 13057",
    d: "M366,232.635l-1.856-4.974a.718.718,0,0,0-.677-.472h-6.707a.728.728,0,0,0-.7.933l1.477,5.025a.728.728,0,0,0,.7.513h7.086a.728.728,0,0,0,.677-1.025Z",
    transform: "translate(-252.45 -141.244)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13058",
    "data-name": "Path 13058",
    d: "M356.753,232.7l-1.487-4.994a.708.708,0,0,0-.687-.513h-7.291a.718.718,0,0,0-.708.872l1.077,5a.738.738,0,0,0,.708.574h7.691a.728.728,0,0,0,.7-.943Z",
    transform: "translate(-252.692 -141.244)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13059",
    "data-name": "Path 13059",
    d: "M300.088,233.7h7.5a.728.728,0,0,0,.718-.687l.246-5.066a.728.728,0,0,0-.728-.759h-7.076a.728.728,0,0,0-.718.636l-.656,5.066a.718.718,0,0,0,.718.81Z",
    transform: "translate(-253.895 -141.244)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13060",
    "data-name": "Path 13060",
    d: "M319.722,233.671h7.107a.718.718,0,0,0,.718-.79l-.462-5.025a.728.728,0,0,0-.718-.667h-6.83a.728.728,0,0,0-.718.759l.185,5.035a.718.718,0,0,0,.718.687Z",
    transform: "translate(-253.399 -141.244)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13061",
    "data-name": "Path 13061",
    d: "M327.74,228.019l.462,5.025a.738.738,0,0,0,.728.656h8.009a.718.718,0,0,0,.718-.82l-.718-5.025a.708.708,0,0,0-.708-.615h-7.763a.728.728,0,0,0-.728.779Z",
    transform: "translate(-253.172 -141.242)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13062",
    "data-name": "Path 13062",
    d: "M346.932,232.758l-1.087-5a.718.718,0,0,0-.708-.564h-6.82a.718.718,0,0,0-.718.82l.718,5.015a.728.728,0,0,0,.718.626h7.178a.728.728,0,0,0,.718-.892Z",
    transform: "translate(-252.92 -141.244)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13063",
    "data-name": "Path 13063",
    d: "M289.863,227.18H274.747a.738.738,0,0,0-.677.461l-1.969,5.128a.718.718,0,0,0,.677.974h15.946a.728.728,0,0,0,.708-.595l1.138-5.127a.728.728,0,0,0-.708-.841Z",
    transform: "translate(-254.591 -141.244)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13064",
    "data-name": "Path 13064",
    d: "M290.648,233.713h7.343a.728.728,0,0,0,.718-.626l.656-5.127a.718.718,0,0,0-.718-.82h-6.861a.728.728,0,0,0-.708.564l-1.138,5.127a.728.728,0,0,0,.708.882Z",
    transform: "translate(-254.135 -141.245)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13065",
    "data-name": "Path 13065",
    d: "M374.608,233.6h4.717a.728.728,0,0,0,.677-1.026l-1.989-4.953a.738.738,0,0,0-.677-.461h-4.317a.738.738,0,0,0-.7.954l1.61,4.953a.738.738,0,0,0,.677.533Z",
    transform: "translate(-252.036 -141.244)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13066",
    "data-name": "Path 13066",
    d: "M373.04,232.656l-1.61-4.963a.728.728,0,0,0-.687-.5h-5.035a.728.728,0,0,0-.677.974l1.846,4.974a.728.728,0,0,0,.687.472h4.789a.718.718,0,0,0,.687-.954Z",
    transform: "translate(-252.222 -141.244)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13067",
    "data-name": "Path 13067",
    d: "M299.417,242.035h7.425a1.077,1.077,0,0,0,1.087-1.025l.256-5.281a1.077,1.077,0,0,0-1.087-1.138H300.1a1.087,1.087,0,0,0-1.087.943l-.687,5.271a1.087,1.087,0,0,0,1.087,1.231Z",
    transform: "translate(-253.921 -141.055)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13068",
    "data-name": "Path 13068",
    d: "M380.39,234.59H369.027A1.087,1.087,0,0,0,368,236.057l2.051,5.384a1.087,1.087,0,0,0,1.026.718h11.516a1.1,1.1,0,0,0,1.025-1.487l-2.112-5.415A1.087,1.087,0,0,0,380.39,234.59Z",
    transform: "translate(-252.147 -141.055)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13069",
    "data-name": "Path 13069",
    d: "M289.36,235.442l-1.179,5.251a1.087,1.087,0,0,0,1.026,1.323h7.353a1.1,1.1,0,0,0,1.077-.954l.687-5.261a1.077,1.077,0,0,0-1.077-1.231h-6.861A1.087,1.087,0,0,0,289.36,235.442Z",
    transform: "translate(-254.181 -141.055)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13070",
    "data-name": "Path 13070",
    d: "M279.639,235.38l-1.549,5.425a.943.943,0,0,0,.9,1.2H286.5a.933.933,0,0,0,.913-.738l1.241-5.527a.933.933,0,0,0-.923-1.149l-7.178.092A.943.943,0,0,0,279.639,235.38Z",
    transform: "translate(-254.438 -141.055)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13071",
    "data-name": "Path 13071",
    d: "M348.271,235.9l1.159,5.363a1.077,1.077,0,0,0,1.026.851h7.609a1.1,1.1,0,0,0,1.025-1.4l-1.6-5.363a1.077,1.077,0,0,0-1.026-.779h-7.178a1.077,1.077,0,0,0-1.015,1.333Z",
    transform: "translate(-252.649 -141.055)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13072",
    "data-name": "Path 13072",
    d: "M308.806,235.626l-.256,5.281a1.087,1.087,0,0,0,1.087,1.149l38.743.061a1.1,1.1,0,0,0,1.025-1.323l-1.159-5.353a1.087,1.087,0,0,0-1.025-.851H309.893A1.087,1.087,0,0,0,308.806,235.626Z",
    transform: "translate(-253.661 -141.055)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13073",
    "data-name": "Path 13073",
    d: "M271.392,235.154l-2.051,5.671a.861.861,0,0,0,.81,1.159h6.3a.882.882,0,0,0,.831-.626l1.62-5.681a.861.861,0,0,0-.831-1.1h-5.835A.861.861,0,0,0,271.392,235.154Z",
    transform: "translate(-254.661 -141.055)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13074",
    "data-name": "Path 13074",
    d: "M358.391,236.035l1.589,5.374a1.1,1.1,0,0,0,1.026.779h6.943a1.087,1.087,0,0,0,1.025-1.466l-2.051-5.384a1.087,1.087,0,0,0-1.026-.708h-6.532a1.087,1.087,0,0,0-.974,1.4Z",
    transform: "translate(-252.391 -141.054)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13075",
    "data-name": "Path 13075",
    d: "M387.533,215.3c0,.144-26.232.267-58.586.267s-58.586-.123-58.586-.267,26.222-.267,58.586-.267S387.533,215.143,387.533,215.3Z",
    transform: "translate(-254.634 -141.554)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13076",
    "data-name": "Path 13076",
    d: "M305.4,167.446a15.382,15.382,0,0,1,3.538-2.2l.215-3.866,6.307-1.025,1.466,3.579a16.091,16.091,0,0,1,4.1.933l2.882-2.564,5.21,3.712-1.5,3.558a15.744,15.744,0,0,1,2.215,3.538l3.856.215,1.025,6.307-3.579,1.466a15.249,15.249,0,0,1-.933,4.1l2.574,2.882-3.712,5.21-3.579-1.507a15.864,15.864,0,0,1-3.528,2.2l-.226,3.856-6.307,1.025-1.466-3.579a15.248,15.248,0,0,1-4.1-.933l-2.841,2.553-5.209-3.712,1.5-3.558a16.214,16.214,0,0,1-2.215-3.538l-3.856-.226-1.026-6.307,3.579-1.466a16.091,16.091,0,0,1,.933-4.1l-2.574-2.882,3.712-5.21,3.569,1.5Zm4.625,7.917a3.123,3.123,0,1,1,0,.01Z",
    transform: "translate(-253.975 -142.947)",
    fill: "#a8e7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13077",
    "data-name": "Path 13077",
    d: "M339.216,183.05a10.561,10.561,0,0,1,2.389-1.487l.154-2.615,4.266-.718,1.025,2.42a10.694,10.694,0,0,1,2.748.636l1.948-1.743,3.528,2.512-1.025,2.41a10.621,10.621,0,0,1,1.487,2.4l2.615.144.718,4.276-2.42,1.025a10.9,10.9,0,0,1-.636,2.748l1.743,1.948-2.523,3.548-2.42-1.025a10.379,10.379,0,0,1-2.389,1.5l-.144,2.615L346,204.36l-1.025-2.43a10.779,10.779,0,0,1-2.748-.626l-1.948,1.733-3.528-2.512,1.025-2.41a10.253,10.253,0,0,1-1.5-2.389l-2.615-.154-.718-4.266,2.43-1.025a10.258,10.258,0,0,1,.626-2.748l-1.743-1.948,2.523-3.528,2.41,1.025Zm3.138,5.363a4.645,4.645,0,1,0,6.471-1.087,4.646,4.646,0,0,0-6.471,1.087Z",
    transform: "translate(-253.039 -142.492)",
    fill: "#a8e7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13078",
    "data-name": "Path 13078",
    d: "M337.247,158.686a9.864,9.864,0,0,1,2.112-1.323l.133-2.307,3.784-.636.872,2.143a9.794,9.794,0,0,1,2.441.564l1.723-1.548,3.077,2.225-.892,2.143a9.117,9.117,0,0,1,1.323,2.113l2.318.133.626,3.784-2.143.872a9.229,9.229,0,0,1-.554,2.441l1.538,1.723-2.225,3.128-2.133-.9a9.228,9.228,0,0,1-2.123,1.323l-.133,2.318-3.774.636-.882-2.143a9.619,9.619,0,0,1-2.43-.564l-1.733,1.538-3.077-2.225.892-2.133a9.539,9.539,0,0,1-1.323-2.123l-2.307-.133-.636-3.774,2.143-.882a9.23,9.23,0,0,1,.564-2.43l-1.548-1.733,2.225-3.076,2.143.892Zm2.769,4.748a4.1,4.1,0,1,0,2.668-1.667A4.1,4.1,0,0,0,340.016,163.434Z",
    transform: "translate(-253.07 -143.099)",
    fill: "#a8e7f7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpsell);
export default __webpack_public_path__ + "static/media/upsell.cd05de168d9628b8a86a5e46844485ac.svg";
export { ForwardRef as ReactComponent };